import BundledEditor from "./TinyMCEBundledEditor";

export default function TinyMCEeditor({ initialValue, editorRef, height = 500}) {
  return (
    <BundledEditor
      onInit={(evt, editor) => {
        if (editorRef) editorRef.current = editor; // 부모 ref에 연결
      }}
      initialValue={initialValue}
      init={{
        height,
        menubar: "file edit insert view format table tools help",
        plugins: [
          "advlist", "anchor", "autolink", "charmap", "codesample",
          "emoticons", "image", "link", "lists", "preview",
          "searchreplace", "table", "visualblocks", "visualchars",
          "wordcount",
        ],
        toolbar:
          "undo redo | blocks | " +
          "bold italic underline forecolor backcolor | " +
          "alignleft aligncenter alignright alignjustify | " +
          "bullist numlist outdent indent | " +
          "link emoticons charmap | " +
          "table | image preview searchreplace visualblocks visualchars | " +
          "removeformat",
        content_style:
          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
      }}
    />
  );
}
